<template>
    <div class="betSlip _singleTicket notranslate" data-bet-slip-scroll-boundary>
        <JackpotWidget v-if="isShowJackpotWidget" v-bind:showCloseButton="false" />
        <div class="betSlip-area">
            <div v-bind:class="{ _stakePadShow: !isShowStakePad }" class="betSlip-scrollContent">
                <EuroOutrightTicket
                    v-bind:key="betSlip.id"
                />
                <Message
                    v-if="betSlip.message.key"
                    status="error"
                    v-bind:messageKey="betSlip.message.key"
                    v-bind:messageData="betSlip.message.data"
                />
                <div class="ticket-maxPayout">
                    <span>{{ i18n.t(betSlipMaxPayoutTranslationKey) }}:</span>
                    <span class="notranslate ticket-amount">{{ maxPayout }}</span>
                </div>
                <div class="ticket-inputArea">
                    <PlaceBet
                        v-bind:stake="stake"
                        v-bind:isDisableBtn="isDisablePlaceBet"
                        v-bind:balance="balance"
                        v-bind:minBet="betSlip.minBet"
                        v-bind:price="betSlip.price"
                        v-on:placeBet="placeBet()"
                        v-on:changeStake="stake = $event"
                    />
                    <StakePad
                        v-bind:stake="stake"
                        v-bind:balance="balance"
                        v-bind:minBet="betSlip.minBet"
                        v-bind:maxBet="betSlip.maxBet"
                        v-bind:currency="customerInfo.currency"
                        v-bind:price="betSlip.price"
                        v-on:changeStake="stake = $event"
                    />
                </div>
                <SwitchAcceptAnyOddsValue
                    v-if="isShowAcceptAnyOdds"
                    class="betSlip-acceptAnyOdds"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed, defineComponent, onUnmounted } from 'vue';
    import SwitchAcceptAnyOddsValue from '@/components/SwitchAcceptAnyOddsValue.vue';
    import EuroOutrightTicket from '@/components/betSlip/EuroOutrightTicket.vue';
    import PlaceBet from '@/components/betSlip/PlaceBet.vue';
    import StakePad from '@/components/betSlip/StakePad.vue';
    import Message from '@/components/common/Message.vue';
    import JackpotWidget from '@/components/jackpot/JackpotWidget.vue';
    import { isBalanceLessMinBet } from '@/libraries/betSlip/stake';
    import { useJackpotDisplay } from '@/libraries/composables/useJackpotDisplay';
    import { i18n } from '@/libraries/i18n';
    import { enableScrolling } from '@/libraries/utils/dom';
    import { useAccountStore } from '@/stores/accountStore';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useOutrightBetSlipStore } from '@/stores/betSlip/outrightBetSlipStore';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';

    export default defineComponent({
        name: 'OutrightBetSlip',
        components: {
            EuroOutrightTicket,
            SwitchAcceptAnyOddsValue,
            JackpotWidget,
            Message,
            PlaceBet,
            StakePad,
        },
        setup() {
            const { isShowJackpotWidget } = useJackpotDisplay();
            const { isShowStakePad } = storeToRefs(useBetSlipStore());
            const { setIsShowStakePad } = useBetSlipStore();

            const { customerInfo, balance } = storeToRefs(useAccountStore());
            const { betSlip, stake, isValidBetSetting, isPlacingBet, maxPayout } = storeToRefs(useOutrightBetSlipStore());
            const { placeBet } = useOutrightBetSlipStore();

            const isShowAcceptAnyOdds = computed(() => !customerInfo.value.isAcceptAnyOdds);

            const { isEuroSite } = storeToRefs(useFeatureToggleStore());
            const betSlipMaxPayoutTranslationKey = computed(() => (isEuroSite.value ? 'payout_EURO' : 'maxPayout'));

            const isDisablePlaceBet = computed(() => {
                if (!isValidBetSetting.value) return true;
                if (isPlacingBet.value) return true;
                if (isBalanceLessMinBet(balance.value, betSlip.value.minBet, betSlip.value.price)) return true;

                if (balance.value === null) return false;

                return Math.floor(balance.value) <= 0;
            });

            onUnmounted(() => {
                enableScrolling();
            });

            setIsShowStakePad(true);

            return {
                isShowJackpotWidget,
                isShowStakePad,
                isShowAcceptAnyOdds,
                balance,
                betSlip,
                i18n,
                customerInfo,
                betSlipMaxPayoutTranslationKey,
                placeBet,
                isDisablePlaceBet,
                stake,
                maxPayout,
            };
        },
    });
</script>

<style lang="scss" scoped>
@import "@/scss/components/betSlip";
@import "@/scss/components/ticket";
</style>
